import { createFilterableCarsAPIClient } from '@/scopes/checkout/filterableCars/infrastructure/api/filterableCarsApiClient';
import { createGetAllCarsResponseMapper } from '@/scopes/checkout/filterableCars/infrastructure/api/getAllCarsResponseMapper';
import type { FilterMappers } from '@/scopes/checkout/filterableCars/domain/types/filterMappers';

import { CarFilterType } from '@/scopes/checkout/filterableCars/domain/types';
import { createMultiValueFilterMapper } from '@/scopes/checkout/filterableCars/infrastructure/api/filter-mappers/multiValueFilterMapper';
import { createSingleValueFilterMapper } from '@/scopes/checkout/filterableCars/infrastructure/api/filter-mappers/singleValueFilterMapper';

export const filtersMappers: FilterMappers = {
  [CarFilterType.AdditionalServices]: createMultiValueFilterMapper(),
  [CarFilterType.CarClass]: createSingleValueFilterMapper(),
  [CarFilterType.DepositPaymentMethod]: createSingleValueFilterMapper(),
  [CarFilterType.PickUpLocation]: createSingleValueFilterMapper(),
  [CarFilterType.Transmission]: createSingleValueFilterMapper(),
  [CarFilterType.FuelType]: createSingleValueFilterMapper(),
};

export const filterableCarsAPIClient = createFilterableCarsAPIClient({
  getAllCarsResponseMapper: createGetAllCarsResponseMapper({ filtersMappers }),
  filtersMappers,
});
